export default {
    general: {
      errors: {
        usernameNotFoundInDatabase: "Логин не найден в базе",
        usernameOrPasswordNotFound: "Логин или пароль не найдены",
        accessDenied: "Доступ запрещен",
        invalidUsernameOrPassword: "Некорректный логин или пароль",
        accountExpired: "Срок действия учетной записи завершен",
        sessionExpired: "Время жизни сессии истекло",
        notModified: "Изменения в базе не произведены"
      },
      errorMessages: {
        details: 'подробнее',
        error: 'Ошибка',
        login: {
          noUsername: "Необходимо ввести имя пользователя",
          noPassword: "Необходимо ввести пароль",
          noLanguage: "Необходимо выбрать язык",
          noConnection: "Необходимо выбрать подключение"
        }
      }
    }
  };
  